'use strict';

/**
 * View/Layout for create/edit object
 *
 * @category   View
 * @module     edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var BaseLayout = require('./base');

var EditLayout = BaseLayout.extend({
    /**
     * Basic mode. Can be either 'create' or 'edit'
     * @type {string}
     */
    mode: 'edit',

    ui: function() {
        return _.extend(BaseLayout.prototype.ui.apply(this, arguments), {
            container: '.edit-container',
            submit: '[data-action="done-edit-object"]',
            scrollContainer: '.modal-body',
        });
    },

    events: function() {
        return _.extend(BaseLayout.prototype.events.apply(this, arguments), {
        });
    },

    /**
     * Event for submitting the form
     * @param {object} event The event object
     * @return {void}
     */
    formSubmit: function(event) {
        var data = this.getData();

        var setIds = data.setIds;
        delete data.setIds;

        var toUnsetSetIds = _.pluck(this.model.getSets(), 'id');
        toUnsetSetIds = _.difference(toUnsetSetIds, setIds);

        // Debug data
        Colido.config.debug && console.info(data);

        if ('Sample specimen' == this.getOption('model').get('objectId')) {
            data.isSample = true;
        }
        this.model.save(data, {
            wait: true,
            success: function(model, response, options) {
                var objectId = model.get('id');
                var catalog = model.collection.catalog;

                //Add sets
                if (_.isArray(setIds)) {
                    setIds.forEach(function(setId) {
                        var setModel = catalog.sets.get(setId);
                        setModel.addItems(objectId);
                    });
                }
                //Unset sets
                if (_.isArray(setIds)) {
                    toUnsetSetIds.forEach(function(setId) {
                        var setModel = catalog.sets.get(setId);
                        setModel.removeItems(objectId);
                    });
                }

                var itemLink = App.html.link({
                    url: '/catalogs/' + catalog.id + '/show/' + objectId,
                    label: '»' + _.escape(model.get('properName')) + '«',
                });

                Messenger().post({
                    type: 'success',
                    message: App.t('collection::edit:response:success:update', {itemLink: itemLink}),
                });

                // Trigger edit of object
                App.vent.trigger('collection:object-edited', model);

                this.wasSaved = true;

                this.trigger('close:modal');
            }.bind(this),
            error: function(model, response, options) {
                this.ui.submit.prop('disabled', false).removeClass('is-loading');

                var errorMessage = Messenger().post({
                    type: 'error',
                    message: App.t('collection::edit:response:error:update'),
                    actions: {
                        'try-again': {
                            label: App.t('global::messenger:button:try-again'),
                            action: function() {
                                errorMessage.hide();
                                this.ui.form.submit();
                            }.bind(this),
                        },
                        'cancel': {
                            label: App.t('global::messenger:button:cancel'),
                            action: function() {
                                errorMessage.hide();
                            }.bind(this),
                        },
                    },
                });
            }.bind(this),
        });

        event.preventDefault();
    },

    /**
     * Event for resetting the form
     * @param {object} event The event object
     * @return {void}
     */
    formReset: function(event) {
        event.preventDefault();
        this.trigger('close:modal', {wasCancled: true});
    },

    onAttach: function() {
        BaseLayout.prototype.onAttach.apply(this, arguments);

        // Check label groups
        var $element;
        this.$('.input-label-group input, .input-label-group textarea').each(function(idx, element) {
            $element = $(element);
            $element.parents('.input-label-group').toggleClass('has-value', $element.val().length > 0);
        });
    },
});

module.exports = EditLayout;